import { render, staticRenderFns } from "./smartup.vue?vue&type=template&id=49acfd74&scoped=true&"
import script from "./smartup.vue?vue&type=script&lang=js&"
export * from "./smartup.vue?vue&type=script&lang=js&"
import style0 from "./smartup.vue?vue&type=style&index=0&id=49acfd74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49acfd74",
  null
  
)

export default component.exports